import React, { useEffect } from "react";

import "./About.css";
import { t } from "i18next";

const About = () => {
    useEffect(() => {
        // Check if there's a hash in the URL when the component loads
        if (window.location.hash) {
            const element = document.getElementById(window.location.hash.substring(1)); // Remove the '#' symbol
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, []);

    return (
        <div className="about">
            <div className='banner' >
                <img className='about-us-banner' src={require('./assets/aboutUsBanner.webp')} />
            </div>
            <div className='about-us-section' id="story">
                <h1>{t('about.title')}</h1>
                <div className='about-us-story'>
                    <p>{t('about.story.0')}</p>
                    <p>{t('about.story.1')}</p>
                    <p>{t('about.story.2')}</p>
                    <p>{t('about.story.3')}</p>
                    <p>{t('about.story.4')}</p>
                    <p>{t('about.story.5')}</p>
                </div>
            </div>
            <div className="store" id="store">
                <h2>{t('about.store.title')}</h2>
                <div className="about-us-store-container">
                    <div className='about-us-store'>
                        <div className='about-us-store-item'>
                            <h3>{t('about.store.address.title')}</h3>
                            <p>{t('about.store.address.0')}</p>
                            <p>{t('about.store.address.1')}</p>
                            <p>{t('about.store.address.2')}</p>
                        </div>
                        <div className='about-us-store-item'>
                            <h3>{t('about.store.phone.title')}</h3>
                            <p>{t('about.store.phone.value')}</p>
                        </div>
                    </div>
                    <div className="about-us-store-item">
                        <img src={require('./assets/map.webp')} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default About;